<template>
  <div class="detail-box">
    <h2 class="is-print-hide title-area">
      <span class="main-title">处方详情</span>
      <div class="handler-area">
        <el-button
          v-if="dropdownItemShow('删除')"
          class="margin-left"
          @click="delPrescription"
          type="info"
          plain
          size="small"
        >
          删除处方
        </el-button>
        <el-button
          @click="download"
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          type="info"
          plain
          size="small"
        >
          下载处方
        </el-button>
        <el-button
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          @click="print"
          type="info"
          plain
          size="small"
        >
          打印处方
        </el-button>
        <el-button
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          @click="receiptPrint"
          type="info"
          plain
          size="small"
        >
          打印小票
        </el-button>
        <!-- <el-button
          @click="downloadEMR"
          class="margin-left"
          v-if="dropdownItemShow('下载')"
          v-permission.not="'h,i,j'"
          type="info"
          plain
          size="small"
        >
          下载电子病历
        </el-button> -->
      </div>
    </h2>
    <breadcrumb firstName="处方列表"></breadcrumb>
    <div class="main is-print-hide">
      <div class="detail" ref="wrapper">
        <prescription-desc :prescriptionDetail="prescriptionDetail" @refreshDetail="fetchDetail" />
        <patient-detail :prescriptionDetail="prescriptionDetail" />
        <div class="advisoryType" v-if="prescriptionDetail.advisoryTypeStr">
          <h3>咨询方式</h3>
          {{ prescriptionDetail.advisoryType | mapAdvisoryType }}
        </div>
        <drug-advice v-if="prescriptionDetail.prescriptionType !== 1" :prescriptionDetail="prescriptionDetail" />
        <chineseDrugAdvice v-else :prescriptionDetail="prescriptionDetail" />
        <prescription-preview
          @download="download"
          v-if="dropdownItemShow('下载')"
          :handlerShow="dropdownItemShow"
          :url="prescriptionDetail.prescriptionColourImgUrl"
          :is-medical-insurance="prescriptionDetail.isMedicalInsurance"
          :no-img-show-text="prescriptionDetail.noImgShowText"
          @print="print"
          @receiptPrint="receiptPrint"
          @del="delPrescription"
          @downloadEMR="downloadEMR"
        />
        <prescription-audit :prescriptionDetail="prescriptionDetail" />
        <im-history :imData="prescriptionDetail.chatMessageList"></im-history>
        <pharmacistContactData
          v-if="prescriptionDetail.videoRecordVos && prescriptionDetail.videoRecordVos.length"
          :videoRecordVos="prescriptionDetail.videoRecordVos"
        />
      </div>
    </div>
    <div class="footer-btn is-print-hide">
      <contact-store from="1" :prescriptionDetail="prescriptionDetail"></contact-store>
    </div>

    <!-- <div class="footer-btn is-print-hide" @click="contactStore">
      <el-popover
        placement="top-start"
        trigger="hover"
        :content="
          `如需${contactMap[prescriptionDetail.showConnect]}，可以在APP端-【全部处方】中打开本处方，发起视频电话`
        "
      >
        <p class="contact" slot="reference">
          {{ contactMap[prescriptionDetail.showConnect] }}
        </p>
      </el-popover>
    </div> -->
  </div>
</template>

<script>
import watermark from '@/util/watermark';
import prescriptionDesc from '@/components/prescriptionDesc.vue';
import patientDetail from '@/components/patientDetail.vue';
import drugAdvice from '@/components/drugAdvice.vue';
import chineseDrugAdvice from './components/chineseDrugAdvice';
import prescriptionAudit from '@/components/prescriptionAudit.vue';
import prescriptionPreview from './components/prescriptionPreview.vue';
import imHistory from '@/components/imHistory.vue';
import printImg from '@/components/printPrescriptionImg';
import breadcrumb from '@/components/global/breadcrumb';
import contactStore from '@/components/global/contactStore/contactStore';
import print from '@/components/printImg/index';
import pharmacistContactData from './components/pharmacistContactData';
import { hasPermission, downloadByLink } from '@/util';
import Constant from '@/lib/constant';
import Fetch from '@/api';
import Vue from 'vue';
import { Popover } from 'element-ui';
import { mapState } from 'vuex';
import DownloadModal from './components/ImageDownloadModal';
import printReceipt from '@/components/printReceipt';

const { prescriptionHandlerRule, baseRole } = Constant;
Vue.use(Popover);
export default {
  name: 'PrescriptionDetail',
  inject: ['_prescription'],
  data() {
    return {
      prescriptionDetail: {},
      auditable: this.$route.query.auditable,
      contactMap: {
        CLERK: '联系店员',
        PHARMACIST: '联系药师'
      }
    };
  },
  mounted() {
    const { userName, companyName } = this.$store.getters;
    watermark.set(`${companyName || ''} ${userName || ''},隐私信息严禁截屏打印`, this.$refs.wrapper);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchDetail();
    });
  },
  beforeRouteLeave(to, from, next) {
    watermark.remove(this.$refs.wrapper);
    next();
  },
  components: {
    prescriptionDesc,
    patientDetail,
    drugAdvice,
    prescriptionAudit,
    prescriptionPreview,
    imHistory,
    printImg,
    breadcrumb,
    contactStore,
    pharmacistContactData,
    chineseDrugAdvice
  },
  computed: {
    ...mapState('video', ['webRtc', 'isCallReceived'])
  },
  methods: {
    fetchDetail() {
      let id = this.$route.params.id;
      Fetch.prescriptionDetail({ id: id }).then(
        data => {
          // 升序排序
          let { chatMessageList } = data;
          if (chatMessageList instanceof Array) {
            chatMessageList = this.timeSort(chatMessageList);
          }
          data.chatMessageList = chatMessageList;
          this.prescriptionDetail = data;
        },
        () => {
          console.log('出错了');
        }
      );
    },
    // 获取要打印图片
    print() {
      const { id } = this.prescriptionDetail;
      Fetch.getImgUrlByPrescriptionIdList({ prescriptionIdList: [id], colourType: 1 }).then(res => {
        if (res.urlInfoList && res.urlInfoList.length > 0) {
          const source = res.urlInfoList.map(v => ({ ...v, prescriptionImg: v.prescriptionImgUrl }));
          print(source, () => Fetch.print_prescription([id]));
        }
      });
    },
    receiptPrint() {
      const { id } = this.prescriptionDetail;
      Fetch.getReceiptPrinting({ prescriptionId: id }).then(res => {
        printReceipt(res);
      });
    },
    timeSort(time) {
      time = time.sort(function (a, b) {
        return a.time - b.time;
      });
      return time;
    },
    dropdownItemShow(type) {
      const state = this.prescriptionDetail.prescriptionTotalStatus;
      if (type === 'all') {
        return Object.values(prescriptionHandlerRule).some(
          ({ rule, status }) => hasPermission(rule) && status.includes(state)
        );
      }
      const { rule, status } = prescriptionHandlerRule[type];
      return hasPermission(rule) && status.includes(state);
    },
    delPrescription() {
      const { id } = this.$route.params;
      this._prescription
        .delPrescription(id)
        .then(res => {
          this.$store.commit('prescription/CHANGEifFreshPrescriptionListState', true);
          this.$router.replace('/prescription');
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 下载pdf
    download() {
      const { id } = this.$route.params;
      DownloadModal.show({
        selectCallback: context => {
          const queryDownload = Object.entries(context.downloadFrom)
            .map(val => val.join('='))
            .join('&');
          this._prescription.downLoadOne(id, queryDownload);
          context.showDownload = false;
          this._prescription.batchIds = [];
        }
      });
    },
    // 下载电子病历
    downloadEMR() {
      const { id } = this.$route.params;
      const query = `pid=${id}`;
      const url = `${Util.getApiRoot}/pr/load/emr/file?${query}`;
      downloadByLink(url, id);
    }
  },
  filters: {
    mapAdvisoryType(val) {
      return Constant.advisoryTypes[val];
    }
  }
};
</script>

<style lang="scss">
.detail-box {
  .title-area {
    position: relative;

    .handler-area {
      position: absolute;
      top: 0;
      right: 0;

      button {
        width: 132px;
        height: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 3px;
        border: 1px solid rgba(242, 242, 242, 1);
        font-size: 12px;
        color: rgba(112, 112, 112, 1);
      }
    }
  }
}

.detail {
  position: relative;
  background: #fff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  min-height: 618px;
  padding: 16px 16px 20px;
  margin: 0px 0 48px;

  h3 {
    height: auto;
    padding: 48px 0 12px;
    font-size: 18px;
    font-family: MicrosoftYaHeiUI;
    font-weight: bold;
    color: rgba(36, 36, 36, 1);
  }

  label {
    display: inline-block;
    color: #242424;
    font-size: 14px;
    margin: 0;
  }

  span {
    font-size: 14px;
    color: #707070;
  }

  .el-row {
    min-height: 40px;
    line-height: 40px;
    // margin-bottom: 10px;
    width: 100%;
    display: inline-block;
  }

  .prescription-img {
    clear: both;
    width: 400px;

    img {
      width: 100%;
    }
  }

  .split-line {
    margin: 20px 0;
  }

  .strong-color {
    color: #f56b56;
  }
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 240px;
  right: 0;
  height: 48px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
  z-index: 999;

  .contact {
    display: flex;
    align-items: center;

    &::before {
      content: '';
      width: 20px;
      height: 20px;
      display: block;
      background: url('../../assets/img/user_header.png') no-repeat;
      background-size: cover;
      margin-right: 5px;
    }
  }
}
</style>
